import { OrderRow } from '../../../BookingsCalendarTypes';
import { transformFormDataToProductList } from '../queries/OrderListApi';

export enum ProductType {
    MAIN = 2,
    ADDITION = 3
}

export function isPossibleToSplit(products: OrderRow[]): boolean {
    if (products.length === 0) {
        return false;
    }

    let splittableProducts = products.filter((product) => product.isPossibleToSplitFromOrder);
    if (splittableProducts.length > 1) {
        return true;
    }

    if (!products.some((product) => product.productType === ProductType.MAIN)) {
        return false;
    }

    return splittableProducts.length > 0;
}

export function separateMainProductsAndAdditionProducts(products: OrderRow[]): {
    mainProducts: OrderRow[];
    additionProducts: OrderRow[];
} {
    return products.reduce(
        (acc, product) => {
            if (product.productType === ProductType.MAIN) {
                acc.mainProducts.push(product);
            } else if (product.productType === ProductType.ADDITION) {
                acc.additionProducts.push(product);
            }

            return acc;
        },
        {
            mainProducts: [] as OrderRow[],
            additionProducts: [] as OrderRow[]
        }
    );
}

export function checkIfNoProductsAreSelected(products: OrderRow[], formData: FormData): boolean {
    return products.reduce((acc, product) => {
        let isChecked = formData.get(`product-${product.productId}`);
        return acc && !Boolean(isChecked);
    }, true);
}

export function checkCanSplitSelected(
    hasMainProduct: boolean,
    products: OrderRow[],
    formData: FormData
): boolean {
    if (hasMainProduct) {
        return true;
    }
    
    let selectedProducts = transformFormDataToProductList(formData);
    return selectedProducts.length < products.length;
}